import { Component, Mixins } from "vue-property-decorator";
import mixins from "@/mixins";
import { SchemeType, Scheme, Contract } from "@foxone/api/src/models/defi";
import { CreateElement, VNode } from "vue/types/umd";
import NormalContractJoin from "defi/components/contracts/join/normal";
import TermContractJoin from "defi/components/contracts/join/term";
import DualNodeContractJoin from "defi/components/contracts/join/dual-node";

@Component
class DetailPage extends Mixins(mixins.page) {
  loading = false;

  scheme: Scheme | null = null;

  contracts: Contract[] = [];

  get title() {
    return this.$t("common.product-detail") as string;
  }

  get type() {
    return this.$route.params.type as SchemeType;
  }

  get id() {
    return this.$route.params.id as string;
  }

  async mounted() {
    this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const actions = this.$api.defi.getActionsBySchemeType(this.type);
      this.scheme = await actions.getSchemeDetail(this.id);
      this.contracts = await actions.getContractsOfScheme(this.id);
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }

  render(h: CreateElement): VNode | null {
    if (this.loading) {
      return h("f-loading", { props: { fullscreen: true, loading: true } });
    }

    if (!this.scheme) return null;

    if (this.type === SchemeType.TERM) {
      return h(TermContractJoin, {
        props: { scheme: this.scheme, contracts: this.contracts }
      });
    }

    if (this.type === SchemeType.DUAL_NODE) {
      return h(DualNodeContractJoin, {
        props: { scheme: this.scheme, contracts: this.contracts }
      });
    }

    return h(NormalContractJoin, {
      props: {
        scheme: this.scheme,
        contracts: this.contracts
      }
    });
  }
}

export default DetailPage;
